import { gql } from "@apollo/client";

const DELETE_NOMINATION = gql`
mutation DeleteNomination($id: String){
    deleteNomination(id: $id)
    }
`;

export default DELETE_NOMINATION;
